export default "__VITE_ASSET__DUr550Jp__"